module.exports = __webpack_public_path__ + "static/media/sigud.0c484dad.png";